<template>
    <!-- Centred over the page, which an open side panel pushes aside. -->
    <div
        dusk="AddOnCaptureHint"
        class="fixed left-[calc(50%_+_(var(--sidebar-offset-left,0px)_-_var(--sidebar-offset-right,0px))_/_2)] top-3 z-99999 flex max-w-[calc(100vw_-_var(--sidebar-offset-left,0px)_-_var(--sidebar-offset-right,0px)_-_24px)] -translate-x-1/2 items-center gap-2 rounded-full bg-theme-accent py-1.5 pl-3 pr-1.5 text-theme-accent-on shadow-pill"
    >
        <svg-icon :icon="icon" width="16px" height="16px" />
        <span :id="hintId" class="truncate text-[12.5px] font-medium">{{ hint }}</span>
        <button
            ref="cancel"
            type="button"
            dusk="AddOnCaptureCancel"
            :aria-describedby="hintId"
            class="inline-flex h-11 shrink-0 items-center rounded-full bg-theme-accent-on px-3 text-[12px] font-medium text-theme-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent-on focus-visible:ring-offset-2 focus-visible:ring-offset-theme-accent md:h-7"
            @click="cancelAddOnEditorAnchorCapture()"
        >
            {{ strings.cancel }}
        </button>
    </div>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapState } from 'vuex';
import { addOnStrings } from './addOnStrings.js';
import { anchorKindKeys } from './addOnAnchorKinds.js';

export default {
    name: 'AddOnCaptureHint',
    computed: {
        ...mapState(['localizations', 'lang']),
        ...mapGetters(['addOnEditorAnchorKind']),
        strings() {
            return addOnStrings(this.localizations, this.lang);
        },
        keys() {
            return anchorKindKeys(this.addOnEditorAnchorKind);
        },
        /** What the page is being asked for. The reader mounts this only during a capture. */
        hint() {
            return (this.keys?.awaiting && this.strings[this.keys.awaiting]) || '';
        },
        icon() {
            return this.keys?.icon ?? '';
        },
        hintId() {
            return `AddOnCaptureHint-${this._uid}`;
        },
    },
    // A passage cannot be selected from the keyboard, so its Cancel is where
    // the keyboard goes. A point is placed from the page, which takes it.
    mounted() {
        if (this.addOnEditorAnchorKind !== 'point') this.$refs.cancel.focus({ preventScroll: true });
    },
    methods: {
        ...mapActions(['cancelAddOnEditorAnchorCapture']),
    },
};
</script>
